var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkStroke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.12109 3.125C3.12109 2.71079 3.45688 2.375 3.87109 2.375H13.2629C13.6771 2.375 14.0129 2.71079 14.0129 3.125V14.5938C14.0129 14.8674 13.8639 15.1193 13.6241 15.2511C13.3842 15.3828 13.0917 15.3735 12.8607 15.2268L8.56701 12.4986L4.27331 15.2268C4.04235 15.3735 3.74979 15.3828 3.50996 15.2511C3.27013 15.1193 3.12109 14.8674 3.12109 14.5938V3.125ZM4.62109 3.875V13.2286L8.16479 10.977C8.41025 10.821 8.72376 10.821 8.96922 10.977L12.5129 13.2286V3.875H4.62109Z",
    fill: "#164A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkStroke);
export default __webpack_public_path__ + "static/media/Bookmark-stroke.4f2103ca3249977d5f407a965ae9aa0a.svg";
export { ForwardRef as ReactComponent };